import { ClientNetworkStatus } from '@confluence/legacy-schema-bridge/entry-points/useNetworkStatusListenerCache.ts';

import {
	isIpBlockedError,
	isRateLimitedError,
	shouldTreatAsOfflineError,
} from './networkStatusMiddlewareUtils.ts';

export interface ErrorHandler<T extends Error = Error> {
	check: (error: Error) => error is T;
	status: ClientNetworkStatus;
	logMessage: string;
	propagateError: boolean;
	/**
	 * Whether a caller may opt this handler out for a single request via `cacheConfig.metadata` (see
	 * `isNoNetworkErrorIgnored`). An opted-out request skips the handler entirely: no status update,
	 * and the error propagates.
	 *
	 * Only the offline handler allows it, mirroring Apollo's `ignoreNoNetworkError`. IP_BLOCKED and
	 * RATE_LIMITED are site-wide conditions Apollo never lets a caller opt out of.
	 */
	allowRequestOptOut?: boolean;
}

export const ERROR_HANDLERS: ReadonlyArray<ErrorHandler> = [
	{
		check: isIpBlockedError,
		status: ClientNetworkStatus.IP_BLOCKED,
		logMessage: 'IP blocked',
		propagateError: false,
	},
	{
		check: isRateLimitedError,
		status: ClientNetworkStatus.RATE_LIMITED,
		logMessage: 'Rate limit was reached',
		propagateError: true,
	},
	{
		check: shouldTreatAsOfflineError,
		status: ClientNetworkStatus.OFFLINE,
		logMessage: 'Network is offline',
		propagateError: false,
		allowRequestOptOut: true,
	},
];
